/*
Description
    Thin API wrapper for the Grower Pool Split detail panel (Project 2116, Almondco
    Intake Masters Migration - #75766). Feature-scoped, matching the sibling
    sales-order-split.service.js convention rather than folding into the general
    IntakeSettingService, since these calls are specific to this one detail panel.

History
    26Aug2026 (SD)
        - #75766: UI - Grower Pool Split detail panel (Review/Edit grid, running Total)

(c) Copyright Graycorp Pty Ltd (ABN 12 082 807 761). All Rights Reserved.
*/
import ApiService from "../../api.service";
import appConfig from "../../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const AlmondcoGrowerPoolSplitService = {
  // §5: AlmondcoGrowerPoolSplitSummary, filtered to a single docket - resolves
  // the identity row (Season/GrowerPoolName) on baseView.id change, whether
  // that's a row click or a direct/bookmarked URL.
  async getPoolSplitSummary(depotDocket) {
    var url = `api/AlmondcoGrowerPoolSplitSummary?$filter=DepotDocket eq '${depotDocket}'`;
    return await ApiService.get(url);
  },

  // §5: api.AlmondcoGrowerSplit shim, filtered to the selected docket - fetched
  // directly here (not left as a grid OData endpoint) since the detail grid
  // manages its rows as a local, mutable array to support Add/Remove Grower
  // rows via DxEditing's native allow-adding/allow-deleting.
  async getGrowerSplit(depotDocket, seasonYear) {
    var url = `api/AlmondcoGrowerSplit?$filter=DepotDocket eq '${depotDocket}' and SeasonYear eq ${seasonYear}`;
    return await ApiService.get(url);
  },

  // §5: Individual/Syndicate growers only, baked into the view predicate. Loaded
  // once (not per-docket) - the Grower picker option list is docket-independent.
  async getRecipientGrowers() {
    return await ApiService.get(
      "api/AlmondcoGrowerRecipientSearch?$orderby=GrowerName",
    );
  },

  async saveGrowerSplit(payload) {
    return await ApiService.post("api/Save_AlmondcoGrowerSplit", payload);
  },

  dataSourceConfig(url, params) {
    return ApiService.createDataSource(url, params);
  },
};

export { AlmondcoGrowerPoolSplitService };
